import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import sendMessageReducer from "../redux/slices/sendmessage";
import globalReducer from "../redux/slices/global"

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    sendMessageReducer,
    globalReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
